import { useCallback } from 'react'
import TitleInput from './TitleInput'
import Callout from '@components/DesignSystem/Callout'
import { useArticleContext } from '../../_core'
import { useTranslation } from 'react-i18next'
import { FOCUS_EDITOR } from '../../_shared/editor-events'
import { useDispatchEvent } from '@hooks/useEventListener'

function TitleInputContainer() {
  const {
    dispatch,
    ActionType,
    articleState: {
      title,
      publish: { timestamp, warnings, action },
    },
  } = useArticleContext()
  const { t } = useTranslation('editor')

  const updateTitleInputChange = useCallback(
    (value: string) => {
      dispatch({ type: ActionType.UPDATE_TITLE, value })
    },
    [dispatch, ActionType],
  )

  const handleTitleInputEnter = useDispatchEvent(FOCUS_EDITOR)

  return (
    <>
      <TitleInput value={title} onChange={updateTitleInputChange} onEnter={handleTitleInputEnter} />
      {warnings?.titleRequired && (
        <Callout
          key={timestamp}
          title={t('warnings.titleRequired.title')}
          message={t(`warnings.titleRequired.message.${action}`)}
        />
      )}
      {warnings?.titleLengthLimited && (
        <Callout
          key={timestamp}
          title={t('warnings.titleLengthLimited.title')}
          message={t(`warnings.titleLengthLimited.message.${action}`)}
        />
      )}
    </>
  )
}

export default TitleInputContainer
